// extracted by mini-css-extract-plugin
export default {"about_container":"About_about_container__FW+J8","mission":"About_mission__Gx6hy","vision":"About_vision__X0ttI","team":"About_team__7XY4O","reasons":"About_reasons__Pbb+1"};